var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEntitlements(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7885 2.5H10.7377C10.2346 1.04688 8.89483 0 7.30769 0C5.72055 0 4.38081 1.04688 3.87841 2.5H1.82692C0.818309 2.5 0 3.33906 0 4.375V18.125C0 19.1602 0.818309 20 1.82692 20H12.7885C13.7971 20 14.6154 19.1609 14.6154 18.125V4.375C14.6154 3.33906 13.7971 2.5 12.7885 2.5ZM7.30769 2.5C7.98023 2.5 8.52564 3.05977 8.52564 3.75C8.52564 4.44023 7.98023 5 7.30769 5C6.63516 5 6.08974 4.44141 6.08974 3.75C6.08974 3.05859 6.63401 2.5 7.30769 2.5ZM10.7674 10.2656L7.41807 14.6406C7.26404 14.842 7.0367 14.9702 6.78892 14.9946C6.75962 14.9648 6.72917 15 6.69872 15C6.48166 15 6.27053 14.9207 6.10421 14.7742L3.9728 12.8992C3.5899 12.5623 3.54575 11.9703 3.87407 11.5773C4.20173 11.1843 4.77877 11.139 5.16205 11.476L6.56954 12.7139L9.32972 9.10918C9.64136 8.70137 10.2165 8.63184 10.6124 8.95051C11.011 9.26953 11.0795 9.85938 10.7674 10.2656Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntitlements);
export default __webpack_public_path__ + "static/media/Entitlements.5755ae1f.svg";
export { ForwardRef as ReactComponent };